import "./sdk.gen-DvYHZRAO.js";
//#region src/generated/schemas.gen.ts
var e = {
	type: "string",
	minLength: 2,
	maxLength: 2,
	pattern: "[A-Z]{2}",
	description: "ISO 3166-1 alpha-2 country code."
}, t = {
	type: "object",
	properties: {
		city: {
			type: "string",
			minLength: 1,
			maxLength: 100,
			description: "The city of the address."
		},
		countryCode: { $ref: "#/components/schemas/CountryCode" },
		street: {
			type: "string",
			minLength: 1,
			maxLength: 100,
			description: "The street of the address."
		},
		additionalInformation: {
			type: "string",
			minLength: 1,
			maxLength: 100,
			description: "Additional information about the address."
		},
		boxNumber: {
			type: "string",
			minLength: 1,
			maxLength: 20,
			description: "The box number of the address, only applicable for specific country codes."
		},
		houseNumber: {
			type: "string",
			minLength: 1,
			maxLength: 25,
			description: "The house number of the address."
		},
		houseNumberSuffix: {
			type: "string",
			minLength: 1,
			maxLength: 25,
			description: "The house number suffix of the address."
		},
		postalCode: {
			type: "string",
			minLength: 1,
			maxLength: 15,
			description: "The postal code of the address."
		},
		region: {
			type: "string",
			minLength: 1,
			maxLength: 100,
			description: "The region of the address."
		},
		state: {
			type: "string",
			minLength: 1,
			maxLength: 100,
			description: "The state of the address."
		}
	},
	required: [
		"city",
		"countryCode",
		"street"
	],
	description: "A physical address."
}, n = {
	type: "string",
	enum: [
		"BPOST",
		"BRT",
		"CHEAP_CARGO",
		"DHL_EUROPLUS",
		"DHL_FOR_YOU",
		"DHL_FREIGHT",
		"DHL_PARCEL_CONNECT",
		"DPD",
		"GLS",
		"INPOST",
		"POSTNL",
		"POSTE_ITALIANE",
		"SPRING",
		"TRUNKRS",
		"UPS_EXPRESS_SAVER",
		"UPS_STANDARD",
		"VIA_TIM",
		"BOL"
	],
	description: "The carrier of the package."
}, r = {
	type: "string",
	enum: [
		"BPOST",
		"BRT",
		"CHEAP_CARGO",
		"DHL_EUROPLUS",
		"DHL_FOR_YOU",
		"DHL_FREIGHT",
		"DHL_PARCEL_CONNECT",
		"DPD",
		"GLS",
		"INPOST",
		"POSTNL",
		"POSTE_ITALIANE",
		"SPRING",
		"TRUNKRS",
		"UPS_EXPRESS_SAVER",
		"UPS_STANDARD",
		"VIA_TIM"
	],
	description: "The carrier to select to ship a package with."
}, i = {
	type: "object",
	properties: {
		groups: {
			type: "array",
			items: {
				type: "object",
				properties: {
					description: {
						type: "string",
						minLength: 1,
						maxLength: 50,
						description: "A clear and detailed description of the goods within this group."
					},
					hsCode: {
						type: "string",
						minLength: 6,
						maxLength: 12,
						description: "The Harmonized System (HS) code for the goods in this group, a globally recognized classification for traded products."
					},
					numberOfItems: {
						type: "integer",
						minimum: 1,
						maximum: 99999,
						description: "The total quantity of individual items within this specific group."
					},
					totalValue: {
						type: "object",
						properties: {
							currency: {
								type: "string",
								minLength: 3,
								maxLength: 3,
								description: "ISO 4217 three-letter currency code."
							},
							micros: {
								type: "integer",
								minimum: 0,
								maximum: 9007199254740991,
								description: "The amount of money in integer micros."
							}
						},
						required: ["currency", "micros"],
						description: "The total declared value of all items within this group."
					},
					totalWeight: {
						type: "object",
						properties: {
							unit: {
								type: "string",
								enum: ["g", "kg"],
								description: "The unit of weight."
							},
							value: {
								type: "integer",
								minimum: 1,
								maximum: 999999999
							}
						},
						required: ["unit", "value"],
						description: "The total weight of all items within this specific group."
					},
					countryCodeOfOrigin: { allOf: [{ $ref: "#/components/schemas/CountryCode" }, { description: "The ISO 3166-1 alpha-2 country code indicating where the goods in this group originated." }] }
				},
				required: [
					"description",
					"hsCode",
					"numberOfItems",
					"totalValue",
					"totalWeight"
				],
				description: "A consolidated group of items within a customs declaration that share common customs attributes."
			},
			minItems: 1,
			maxItems: 100,
			description: "The list of item groups."
		},
		purpose: {
			type: "string",
			enum: [
				"COMMERCIAL_GOODS",
				"COMMERCIAL_SAMPLE",
				"DOCUMENTS",
				"GIFT",
				"RETURNED_GOODS"
			],
			description: "The primary reason or purpose for the international shipment."
		},
		totalWeight: {
			type: "object",
			properties: {
				unit: {
					type: "string",
					enum: ["g", "kg"],
					description: "The unit of weight."
				},
				value: {
					type: "integer",
					minimum: 1,
					maximum: 999999999
				}
			},
			required: ["unit", "value"],
			description: "The total weight of all items declared within this customs declaration."
		},
		invoiceNumber: {
			type: "string",
			minLength: 1,
			maxLength: 150,
			description: "The identifying number of the commercial invoice associated with this shipment."
		}
	},
	required: [
		"groups",
		"purpose",
		"totalWeight"
	],
	description: "The official declaration of goods for customs clearance purposes during international shipment."
}, a = {
	type: "object",
	properties: {
		groups: {
			type: "array",
			items: {
				type: "object",
				properties: {
					description: {
						type: "string",
						minLength: 1,
						maxLength: 100,
						description: "A clear and detailed description of the goods within this group."
					},
					hsCode: {
						type: "string",
						minLength: 6,
						maxLength: 12,
						description: "The Harmonized System (HS) code for the goods in this group, a globally recognized classification for traded products."
					},
					numberOfItems: {
						type: "integer",
						minimum: 1,
						maximum: 99999,
						description: "The total quantity of individual items within this specific group."
					},
					totalValue: {
						type: "object",
						properties: {
							currency: {
								type: "string",
								minLength: 3,
								maxLength: 3,
								description: "ISO 4217 three-letter currency code."
							},
							micros: {
								type: "integer",
								minimum: 0,
								maximum: 9007199254740991,
								description: "The amount of money in integer micros."
							}
						},
						required: ["currency", "micros"],
						description: "The total declared value of all items within this group."
					},
					totalWeight: {
						type: "object",
						properties: {
							unit: {
								type: "string",
								enum: ["g", "kg"],
								description: "The total weight of all items within this specific group."
							},
							value: {
								type: "integer",
								minimum: 1,
								maximum: 999999999
							}
						},
						required: ["unit", "value"],
						description: "The total weight of all items within this specific group."
					},
					countryCodeOfOrigin: { allOf: [{ $ref: "#/components/schemas/CountryCode" }, { description: "The ISO 3166-1 alpha-2 country code indicating where the goods in this group originated." }] }
				},
				required: [
					"description",
					"hsCode",
					"numberOfItems",
					"totalValue",
					"totalWeight"
				],
				description: "A consolidated group of items within a customs declaration that share common customs attributes."
			},
			minItems: 1,
			maxItems: 100,
			description: "The list of item groups."
		},
		purpose: {
			type: "string",
			enum: [
				"COMMERCIAL_GOODS",
				"COMMERCIAL_SAMPLE",
				"DOCUMENTS",
				"GIFT",
				"RETURNED_GOODS"
			],
			description: "The primary reason or purpose for the international shipment."
		},
		totalWeight: {
			type: "object",
			properties: {
				unit: {
					type: "string",
					enum: ["g", "kg"],
					description: "The total weight of all items declared within this customs declaration."
				},
				value: {
					type: "integer",
					minimum: 1,
					maximum: 999999999
				}
			},
			required: ["unit", "value"],
			description: "The total weight of all items declared within this customs declaration."
		},
		invoiceNumber: {
			type: "string",
			minLength: 1,
			maxLength: 150,
			description: "The identifying number of the commercial invoice associated with this shipment."
		}
	},
	required: [
		"groups",
		"purpose",
		"totalWeight"
	],
	description: "The official declaration of goods for customs clearance purposes during international shipment."
}, o = {
	type: "string",
	minLength: 1,
	maxLength: 100,
	description: "The customer reference of the order."
}, s = {
	type: "string",
	enum: [
		"EARLY_MORNING_DELIVERY",
		"EVENING_DELIVERY",
		"EXPRESS_DELIVERY",
		"MORNING_DELIVERY",
		"PICKUP_EXPRESS_DELIVERY",
		"PICKUP_DELIVERY",
		"SAME_DAY_DELIVERY",
		"STANDARD_DELIVERY"
	],
	description: "The delivery type of the shipment."
}, c = {
	type: "object",
	properties: {
		notifyOnDelivery: {
			type: "object",
			additionalProperties: !1,
			description: "Notify sender upon package delivery."
		},
		preferredDate: {
			type: "object",
			properties: { date: {
				type: "string",
				format: "date",
				description: "Recipient specified preferred delivery date."
			} },
			required: ["date"],
			description: "This option allows you to set a preferred date for delivery, so a drop off date can be calculated."
		}
	},
	description: "Options regarding delivery timing and notifications."
}, l = {
	type: "object",
	properties: {
		options: { $ref: "#/components/schemas/DeliveryOptions" },
		type: { $ref: "#/components/schemas/DeliveryType" }
	},
	description: "The delivery details of the shipment."
}, u = {
	type: "object",
	properties: { date: {
		type: "string",
		format: "date",
		description: "The date at which to drop off the package."
	} },
	description: "The drop-off details."
}, d = {
	type: "object",
	properties: {
		currency: {
			type: "string",
			minLength: 3,
			maxLength: 3,
			description: "ISO 4217 three-letter currency code."
		},
		micros: {
			type: "integer",
			minimum: 0,
			maximum: 9007199254740991,
			description: "The amount of money in integer micros."
		}
	},
	required: ["currency", "micros"],
	description: "A monetary value represented by split integral and fractional parts to avoid floating point errors."
}, f = {
	type: "string",
	enum: ["EU", "NON_EU"],
	description: "A geographic area code that represents a specific list of countries."
}, p = {
	type: "string",
	enum: [
		"CANCELED",
		"COMPLETED",
		"DISCOVERED",
		"IMPORT_REQUESTED",
		"OPEN",
		"PROCESSING",
		"RETURNING"
	],
	description: "The status of the order."
}, m = {
	type: "string",
	enum: [
		"DIGITAL_STAMP",
		"ENVELOPE",
		"MAILBOX",
		"PACKAGE",
		"PALLET",
		"SMALL_PACKAGE",
		"UNFRANKED"
	],
	description: "The type of the package."
}, h = { anyOf: [
	{
		type: "object",
		properties: {
			group: {
				type: "string",
				enum: ["PICKING_AND_PACKING"]
			},
			name: {
				type: "string",
				enum: ["PACKED"]
			}
		},
		required: ["group", "name"]
	},
	{
		type: "object",
		properties: {
			group: {
				type: "string",
				enum: ["DISPATCHING"]
			},
			name: {
				type: "string",
				enum: ["READY_TO_SHIP"]
			}
		},
		required: ["group", "name"]
	},
	{
		type: "object",
		properties: {
			group: {
				type: "string",
				enum: ["DISPATCHING"]
			},
			name: {
				type: "string",
				enum: ["LABELED"]
			}
		},
		required: ["group", "name"]
	},
	{
		type: "object",
		properties: {
			group: {
				type: "string",
				enum: ["DISPATCHING"]
			},
			name: {
				type: "string",
				enum: ["HANDED_OVER"]
			}
		},
		required: ["group", "name"]
	},
	{
		type: "object",
		properties: {
			group: {
				type: "string",
				enum: ["UNTRACEABLE"]
			},
			name: {
				type: "string",
				enum: ["LABELED"]
			}
		},
		required: ["group", "name"]
	},
	{
		type: "object",
		properties: {
			group: {
				type: "string",
				enum: ["SORTING"]
			},
			name: {
				type: "string",
				enum: ["IN_SORTING_PROCESS"]
			}
		},
		required: ["group", "name"]
	},
	{
		type: "object",
		properties: {
			group: {
				type: "string",
				enum: ["DISTRIBUTING"]
			},
			name: {
				type: "string",
				enum: ["OUT_FOR_DELIVERY"]
			}
		},
		required: ["group", "name"]
	},
	{
		type: "object",
		properties: {
			group: {
				type: "string",
				enum: ["DISTRIBUTING"]
			},
			name: {
				type: "string",
				enum: ["AT_CUSTOMS"]
			}
		},
		required: ["group", "name"]
	},
	{
		type: "object",
		properties: {
			group: {
				type: "string",
				enum: ["DISTRIBUTING"]
			},
			name: {
				type: "string",
				enum: ["AT_PICKUP_POINT"]
			}
		},
		required: ["group", "name"]
	},
	{
		type: "object",
		properties: {
			group: {
				type: "string",
				enum: ["DELIVERED"]
			},
			name: {
				type: "string",
				enum: ["AT_AGREED_LOCATION"]
			}
		},
		required: ["group", "name"]
	},
	{
		type: "object",
		properties: {
			group: {
				type: "string",
				enum: ["DELIVERED"]
			},
			name: {
				type: "string",
				enum: ["AT_RECIPIENT"]
			}
		},
		required: ["group", "name"]
	},
	{
		type: "object",
		properties: {
			group: {
				type: "string",
				enum: ["DELIVERED"]
			},
			name: {
				type: "string",
				enum: ["AT_SENDER"]
			}
		},
		required: ["group", "name"]
	},
	{
		type: "object",
		properties: {
			group: {
				type: "string",
				enum: ["DELIVERED"]
			},
			name: {
				type: "string",
				enum: ["MARKED_AS"]
			}
		},
		required: ["group", "name"]
	},
	{
		type: "object",
		properties: {
			group: {
				type: "string",
				enum: ["DELIVERED"]
			},
			name: {
				type: "string",
				enum: ["PICKED_UP"]
			}
		},
		required: ["group", "name"]
	}
] }, g = {
	type: "string",
	enum: [
		"PAID",
		"PENDING",
		"UNPAID"
	],
	description: "The current payment status."
}, _ = {
	type: "object",
	properties: {
		height: {
			type: "object",
			properties: {
				unit: {
					type: "string",
					enum: [
						"mm",
						"cm",
						"m"
					],
					description: "The unit of measurement for length, width, or height."
				},
				value: {
					type: "integer",
					minimum: 1,
					maximum: 1e6,
					description: "The dimension value."
				}
			},
			required: ["unit", "value"],
			description: "The height."
		},
		length: {
			type: "object",
			properties: {
				unit: {
					type: "string",
					enum: [
						"mm",
						"cm",
						"m"
					],
					description: "The unit of measurement for length, width, or height."
				},
				value: {
					type: "integer",
					minimum: 1,
					maximum: 1e6,
					description: "The dimension value."
				}
			},
			required: ["unit", "value"],
			description: "The length."
		},
		weight: {
			type: "object",
			properties: {
				unit: {
					type: "string",
					enum: ["g", "kg"],
					description: "The unit of weight."
				},
				value: {
					type: "integer",
					minimum: 1,
					maximum: 999999999
				}
			},
			required: ["unit", "value"],
			description: "The weight."
		},
		width: {
			type: "object",
			properties: {
				unit: {
					type: "string",
					enum: [
						"mm",
						"cm",
						"m"
					],
					description: "The unit of measurement for length, width, or height."
				},
				value: {
					type: "integer",
					minimum: 1,
					maximum: 1e6,
					description: "The dimension value."
				}
			},
			required: ["unit", "value"],
			description: "The width."
		}
	}
}, v = {
	type: "object",
	properties: {
		height: {
			type: "object",
			properties: {
				unit: {
					type: "string",
					enum: [
						"mm",
						"cm",
						"m"
					],
					description: "The unit of measurement for length, width, or height."
				},
				value: {
					type: "integer",
					minimum: 1,
					maximum: 1e6,
					description: "The dimension value."
				}
			},
			required: ["unit", "value"],
			description: "The height."
		},
		length: {
			type: "object",
			properties: {
				unit: {
					type: "string",
					enum: [
						"mm",
						"cm",
						"m"
					],
					description: "The unit of measurement for length, width, or height."
				},
				value: {
					type: "integer",
					minimum: 1,
					maximum: 1e6,
					description: "The dimension value."
				}
			},
			required: ["unit", "value"],
			description: "The length."
		},
		weight: {
			type: "object",
			properties: {
				unit: {
					type: "string",
					enum: ["g", "kg"],
					description: "The unit of weight."
				},
				value: {
					type: "integer",
					minimum: 1,
					maximum: 999999999
				}
			},
			required: ["unit", "value"],
			description: "The physical weight."
		},
		width: {
			type: "object",
			properties: {
				unit: {
					type: "string",
					enum: [
						"mm",
						"cm",
						"m"
					],
					description: "The unit of measurement for length, width, or height."
				},
				value: {
					type: "integer",
					minimum: 1,
					maximum: 1e6,
					description: "The dimension value."
				}
			},
			required: ["unit", "value"],
			description: "The width."
		}
	},
	required: ["weight"],
	description: "The physical dimensions."
}, y = {
	anyOf: [{ $ref: "#/components/schemas/CountryCode" }, { $ref: "#/components/schemas/GeoAreaCode" }],
	description: "A region identifier: either an ISO country code or a defined geographic area."
}, b = {
	type: "string",
	enum: ["OUTBOUND", "INBOUND"],
	description: "The direction of the shipment. OUTBOUND is from sender to recipient, INBOUND is from recipient to sender."
}, x = {
	type: "object",
	properties: {
		additionalInsurance: {
			type: "object",
			additionalProperties: !1,
			description: "Provides enhanced insurance coverage beyond the standard amount."
		},
		deliverAtPostalPoint: {
			type: "object",
			additionalProperties: !1,
			description: "Indicates that the parcel will be delivered to a designated postal service point rather than the recipient's address, requiring the recipient to collect it from that location."
		},
		freshFood: {
			type: "object",
			additionalProperties: !1,
			description: "Designates the shipment as containing perishable, non-frozen food items, ensuring appropriate handling procedures are applied to maintain freshness and prevent spoilage during transit."
		},
		frozen: {
			type: "object",
			additionalProperties: !1,
			description: "Specifies that the shipment contains items that must remain frozen, necessitating strict, continuous temperature-controlled environments throughout the transit process to prevent thawing."
		},
		hideSender: {
			type: "object",
			additionalProperties: !1,
			description: "Omits the sender's information from the shipping label, maintaining sender anonymity in the delivery process."
		},
		insurance: {
			type: "object",
			properties: { amount: {
				type: "object",
				properties: {
					currency: {
						type: "string",
						minLength: 3,
						maxLength: 3,
						description: "ISO 4217 three-letter currency code."
					},
					micros: {
						type: "integer",
						minimum: 0,
						maximum: 9007199254740991,
						description: "The amount of money in integer micros."
					}
				},
				required: ["currency", "micros"],
				description: "The amount to insure."
			} },
			required: ["amount"],
			description: "Provides standard insurance coverage up to the specified monetary amount."
		},
		noTracking: {
			type: "object",
			additionalProperties: !1,
			description: "Disables all tracking and tracing capabilities for the shipment."
		},
		oversizedPackage: {
			type: "object",
			additionalProperties: !1,
			description: "Designates the shipment as exceeding standard size limitations, requiring special handling procedures and potentially incurring additional fees."
		},
		printReturnLabelAtDropOff: {
			type: "object",
			additionalProperties: !1,
			description: "Provides the recipient with a digital identifier that can be presented at a drop-off location to print the return label on-site. This option is only applicable for inbound shipments."
		},
		priorityDelivery: {
			type: "object",
			additionalProperties: !1,
			description: "Designates the shipment for expedited processing and transport through the delivery network, often resulting in a faster transit time compared to standard services."
		},
		recipientOnlyDelivery: {
			type: "object",
			additionalProperties: !1,
			description: "Restricts delivery exclusively to the named recipient, requiring verification of recipient identity and prohibiting delivery to anyone else at the same address."
		},
		requiresAgeVerification: {
			type: "object",
			additionalProperties: !1,
			description: "Requires the recipient to provide valid identification to verify they meet the minimum age requirement before the package can be released, typically used for age-restricted items."
		},
		requiresCashOnDelivery: {
			type: "object",
			additionalProperties: !1,
			description: "Mandates that the carrier collect the full order amount in cash from the recipient upon delivery, ensuring payment is secured before the goods are handed over."
		},
		requiresReceiptCode: {
			type: "object",
			additionalProperties: !1,
			description: "Requires the recipient to provide a specific verification code at the time of delivery, adding an extra layer of security and confirmation for sensitive shipments."
		},
		requiresSignature: {
			type: "object",
			additionalProperties: !1,
			description: "Mandates that the recipient or authorized representative must provide a signature upon delivery, creating proof of receipt and transfer of responsibility."
		},
		returnContributionFee: {
			type: "object",
			properties: { amount: {
				type: "object",
				properties: {
					currency: {
						type: "string",
						minLength: 3,
						maxLength: 3,
						description: "ISO 4217 three-letter currency code."
					},
					micros: {
						type: "integer",
						minimum: 0,
						maximum: 9007199254740991,
						description: "The amount of money in integer micros."
					}
				},
				required: ["currency", "micros"],
				description: "The amount of the contribution."
			} },
			required: ["amount"],
			description: "Specifies that the recipient must pay the designated contribution amount toward the cost of returning the item. This option is only applicable for inbound shipments."
		},
		returnOnFirstFailedDelivery: {
			type: "object",
			additionalProperties: !1,
			description: "Instructs the carrier to return the package to the sender immediately after the first unsuccessful delivery attempt, bypassing the standard redelivery procedures or holding period."
		},
		sameDayDelivery: {
			type: "object",
			additionalProperties: !1,
			description: "Expedited delivery within the same calendar day that the shipping label is created."
		},
		saturdayDelivery: {
			type: "object",
			additionalProperties: !1,
			description: "Enables delivery on Saturday, which is typically outside standard delivery days, ensuring the package arrives before the start of the following work week."
		},
		scheduledCollection: {
			type: "object",
			additionalProperties: !1,
			description: "Arranges for the carrier to pick up the package from the sender's location, eliminating the need for the sender to drop off the package."
		}
	},
	description: "Options applicable to shipments."
}, S = {
	type: "object",
	properties: { customLabelText: {
		type: "object",
		properties: { text: {
			type: "string",
			minLength: 1,
			maxLength: 45,
			description: "Allows adding personalized text to be printed on the shipping label, which can include special handling instructions or reference information."
		} },
		required: ["text"],
		description: "Defines a custom text to be printed on the shipping label."
	} },
	description: "Options applicable to individual packages of a shipment."
}, C = {
	allOf: [{ $ref: "#/components/schemas/ShipmentOptionsCommon" }, { $ref: "#/components/schemas/ShipmentOptionsPackage" }],
	description: "Options applicable to shipments."
}, w = {
	type: "string",
	enum: ["ASC", "DESC"],
	description: "Specifies the ordering of results: ascending (ASC) or descending (DESC)."
}, T = {
	type: "object",
	properties: {
		emailAddress: {
			type: "string",
			minLength: 1,
			maxLength: 320,
			description: "An email address."
		},
		locale: {
			anyOf: [{
				type: "string",
				minLength: 5,
				maxLength: 5,
				description: "Combination of ISO 639-1 and ISO 3166-1 alpha-2 separated by a hyphen."
			}, {
				type: "string",
				minLength: 2,
				maxLength: 2,
				description: "ISO 639-1 language code."
			}],
			description: "A value that is either a full locale or just a language code."
		},
		phoneNumber: {
			type: "string",
			minLength: 1,
			maxLength: 50,
			description: "The phone number of the contact."
		},
		type: {
			type: "string",
			enum: ["BUSINESS"],
			description: "Discriminator for business contacts."
		},
		company: {
			type: "string",
			minLength: 1,
			maxLength: 100,
			description: "The name of the company."
		},
		attention: {
			type: "string",
			minLength: 1,
			maxLength: 100,
			description: "The name of the contact person."
		},
		vatNumbersByCountry: {
			type: "object",
			additionalProperties: {
				type: "string",
				minLength: 1,
				maxLength: 20,
				description: "The VAT registration number for the given country."
			},
			description: "A collection of VAT registration numbers of the company, indexed by ISO country code.",
			propertyNames: { $ref: "#/components/schemas/CountryCode" }
		},
		voecNumber: {
			type: "string",
			minLength: 1,
			maxLength: 20,
			description: "The VOEC number of the company."
		},
		eoriNumber: {
			type: "string",
			minLength: 1,
			maxLength: 20,
			description: "The EORI number of the company."
		}
	},
	required: ["type", "company"]
}, E = {
	type: "object",
	properties: {
		emailAddress: {
			type: "string",
			minLength: 1,
			maxLength: 320,
			description: "An email address."
		},
		locale: {
			anyOf: [{
				type: "string",
				minLength: 5,
				maxLength: 5,
				description: "Combination of ISO 639-1 and ISO 3166-1 alpha-2 separated by a hyphen."
			}, {
				type: "string",
				minLength: 2,
				maxLength: 2,
				description: "ISO 639-1 language code."
			}],
			description: "A value that is either a full locale or just a language code."
		},
		phoneNumber: {
			type: "string",
			minLength: 1,
			maxLength: 50,
			description: "The phone number of the contact."
		},
		type: {
			type: "string",
			enum: ["PRIVATE"],
			description: "Discriminator for private contacts."
		},
		name: {
			type: "string",
			minLength: 1,
			maxLength: 200,
			description: "The name of the contact person."
		}
	},
	required: ["type", "name"]
}, D = {
	oneOf: [{ $ref: "#/components/schemas/ContactBusiness" }, { $ref: "#/components/schemas/ContactPrivate" }],
	discriminator: {
		propertyName: "type",
		mapping: {
			BUSINESS: "#/components/schemas/ContactBusiness",
			PRIVATE: "#/components/schemas/ContactPrivate"
		}
	}
}, O = {
	type: "object",
	properties: {
		locale: {
			anyOf: [{
				type: "string",
				minLength: 5,
				maxLength: 5,
				description: "Combination of ISO 639-1 and ISO 3166-1 alpha-2 separated by a hyphen."
			}, {
				type: "string",
				minLength: 2,
				maxLength: 2,
				description: "ISO 639-1 language code."
			}],
			description: "A value that is either a full locale or just a language code."
		},
		phoneNumber: {
			type: "string",
			minLength: 1,
			maxLength: 50,
			description: "The phone number of the contact."
		},
		type: {
			type: "string",
			enum: ["BUSINESS"],
			description: "Discriminator for business contacts."
		},
		company: {
			type: "string",
			minLength: 1,
			maxLength: 100,
			description: "The name of the company."
		},
		attention: {
			type: "string",
			minLength: 1,
			maxLength: 100,
			description: "The name of the contact person."
		},
		vatNumbersByCountry: {
			type: "object",
			additionalProperties: {
				type: "string",
				minLength: 1,
				maxLength: 20,
				description: "The VAT registration number for the given country."
			},
			description: "A collection of VAT registration numbers of the company, indexed by ISO country code.",
			propertyNames: { $ref: "#/components/schemas/CountryCode" }
		},
		voecNumber: {
			type: "string",
			minLength: 1,
			maxLength: 20,
			description: "The VOEC number of the company."
		},
		eoriNumber: {
			type: "string",
			minLength: 1,
			maxLength: 20,
			description: "The EORI number of the company."
		},
		emailAddresses: {
			type: "array",
			items: {
				type: "string",
				minLength: 1,
				maxLength: 320,
				description: "An email address."
			},
			minItems: 1,
			maxItems: 5,
			description: "The email addresses of the contact. The first email address will be used as the primary email address. The remaining will be used as extra email addresses if the right permissions are present."
		}
	},
	required: ["type", "company"],
	description: "A business contact that supports multiple email addresses."
}, k = {
	type: "object",
	properties: {
		locale: {
			anyOf: [{
				type: "string",
				minLength: 5,
				maxLength: 5,
				description: "Combination of ISO 639-1 and ISO 3166-1 alpha-2 separated by a hyphen."
			}, {
				type: "string",
				minLength: 2,
				maxLength: 2,
				description: "ISO 639-1 language code."
			}],
			description: "A value that is either a full locale or just a language code."
		},
		phoneNumber: {
			type: "string",
			minLength: 1,
			maxLength: 50,
			description: "The phone number of the contact."
		},
		type: {
			type: "string",
			enum: ["PRIVATE"],
			description: "Discriminator for private contacts."
		},
		name: {
			type: "string",
			minLength: 1,
			maxLength: 200,
			description: "The name of the contact person."
		},
		emailAddresses: {
			type: "array",
			items: {
				type: "string",
				minLength: 1,
				maxLength: 320,
				description: "An email address."
			},
			minItems: 1,
			maxItems: 5,
			description: "The email addresses of the contact. The first email address will be used as the primary email address. The remaining will be used as extra email addresses if the right permissions are present."
		}
	},
	required: ["type", "name"],
	description: "A private contact that supports multiple email addresses."
}, A = {
	oneOf: [{ $ref: "#/components/schemas/ContactMultiEmailBusiness" }, { $ref: "#/components/schemas/ContactMultiEmailPrivate" }],
	discriminator: {
		propertyName: "type",
		mapping: {
			BUSINESS: "#/components/schemas/ContactMultiEmailBusiness",
			PRIVATE: "#/components/schemas/ContactMultiEmailPrivate"
		}
	}
}, j = {
	type: "object",
	properties: {
		address: { $ref: "#/components/schemas/Address" },
		contact: { $ref: "#/components/schemas/Contact" }
	},
	description: "The billing details of an order."
}, M = {
	type: "object",
	properties: {
		name: {
			type: "string",
			enum: [
				"BOL",
				"CSCART",
				"GENERIC",
				"LIGHTSPEED",
				"MAGENTO",
				"PRESTA",
				"SHOPIFY",
				"WOOCOMMERCE"
			],
			description: "The identifier of the external e-commerce platform."
		},
		sourceId: {
			type: "string",
			minLength: 1,
			maxLength: 50,
			description: "The order ID as defined in the source system."
		}
	},
	required: ["name", "sourceId"],
	description: "The external reference of the ecommerce platform."
}, N = {
	type: "object",
	properties: {
		id: {
			type: "string",
			minLength: 1,
			maxLength: 50,
			description: "The unique identifier of the sales channel."
		},
		name: {
			type: "string",
			minLength: 3,
			maxLength: 50,
			description: "The name of the sales channel at the time of import."
		}
	},
	required: ["id", "name"],
	description: "The external reference of the sales channel."
}, P = {
	type: "object",
	properties: {
		source: {
			type: "string",
			enum: ["SALES_CHANNEL"]
		},
		salesChannel: { $ref: "#/components/schemas/ExternalReferenceSalesChannel" },
		ecommercePlatform: { $ref: "#/components/schemas/ExternalReferenceEcommercePlatform" }
	},
	required: [
		"source",
		"salesChannel",
		"ecommercePlatform"
	]
}, F = {
	type: "object",
	properties: { source: {
		type: "string",
		enum: ["MYPARCEL_SHOP"]
	} },
	required: ["source"],
	description: "This external reference is set when the order originates from an \"etiketten\" shipment. The only actions allowed on this type of order is cancel"
}, I = {
	type: "object",
	properties: {
		source: {
			type: "string",
			enum: ["IMPORT"]
		},
		sourceId: {
			type: "string",
			minLength: 1,
			maxLength: 50,
			description: "The order ID as defined in the source system."
		}
	},
	required: ["source", "sourceId"],
	description: "This external reference is set when the order originates from a generic ecommerce order import"
}, L = {
	oneOf: [
		{ $ref: "#/components/schemas/ExternalReferencesSalesChannel" },
		{ $ref: "#/components/schemas/ExternalReferencesMyParcelShop" },
		{ $ref: "#/components/schemas/ExternalReferencesImport" }
	],
	discriminator: {
		propertyName: "source",
		mapping: {
			SALES_CHANNEL: "#/components/schemas/ExternalReferencesSalesChannel",
			MYPARCEL_SHOP: "#/components/schemas/ExternalReferencesMyParcelShop",
			IMPORT: "#/components/schemas/ExternalReferencesImport"
		}
	}
}, R = {
	type: "object",
	properties: { sourceId: {
		type: "string",
		minLength: 1,
		maxLength: 50,
		description: "The order line ID as defined in the source system."
	} },
	required: ["sourceId"],
	description: "The external reference of the order line."
}, z = {
	type: "object",
	properties: {
		credited: {
			type: "boolean",
			description: "Whether the label is credited by us."
		},
		createdBy: {
			anyOf: [{
				type: "string",
				pattern: "^shop\\/.{1,250}$",
				description: "A shop principal identifier."
			}, {
				type: "string",
				pattern: "^user\\/.{1,250}$",
				description: "A user principal identifier."
			}],
			description: "Which principal created the label."
		},
		paymentStatus: { $ref: "#/components/schemas/PaymentStatus" },
		barcode: {
			type: "string",
			minLength: 1,
			maxLength: 50,
			description: "The barcode of the label."
		},
		delayed: {
			type: "boolean",
			description: "Whether the shipment is delayed."
		},
		partnerBarcodes: {
			type: "array",
			items: {
				type: "string",
				minLength: 1,
				maxLength: 50,
				description: "The barcode identifier associated with the shipment label."
			},
			minItems: 1,
			maxItems: 5,
			description: "The partner barcodes when the parcel is taken over by a partner carrier."
		}
	},
	required: [
		"credited",
		"barcode",
		"delayed"
	]
}, B = {
	type: "object",
	properties: {
		credited: {
			type: "boolean",
			description: "Whether the label is credited by us."
		},
		createdBy: {
			anyOf: [{
				type: "string",
				pattern: "^shop\\/.{1,250}$",
				description: "A shop principal identifier."
			}, {
				type: "string",
				pattern: "^user\\/.{1,250}$",
				description: "A user principal identifier."
			}],
			description: "Which principal created the label."
		},
		paymentStatus: { $ref: "#/components/schemas/PaymentStatus" }
	},
	required: ["credited"]
}, V = {
	type: "object",
	properties: {
		type: {
			type: "string",
			enum: ["IMPORTED"]
		},
		id: {
			type: "string",
			format: "uuid",
			description: "The unique identifier of a note of an order."
		},
		notedAt: {
			anyOf: [{ type: "string" }, {
				type: "string",
				format: "date-time",
				description: "An ISO 8601 formatted datetime string with timezone offset."
			}],
			description: "The date and time the note was created."
		},
		origin: {
			type: "string",
			enum: ["SALES_CHANNEL"],
			description: "The origin of the note."
		},
		text: {
			type: "string",
			minLength: 1,
			maxLength: 2500,
			description: "The text of the note."
		},
		author: {
			type: "string",
			minLength: 1,
			maxLength: 200,
			description: "The author of the note."
		},
		locale: {
			anyOf: [{
				type: "string",
				minLength: 5,
				maxLength: 5,
				description: "Combination of ISO 639-1 and ISO 3166-1 alpha-2 separated by a hyphen."
			}, {
				type: "string",
				minLength: 2,
				maxLength: 2,
				description: "ISO 639-1 language code."
			}],
			description: "The locale of the note."
		},
		updatedAt: {
			anyOf: [{ type: "string" }, {
				type: "string",
				format: "date-time",
				description: "An ISO 8601 formatted datetime string with timezone offset."
			}],
			description: "The date and time the note was last updated."
		}
	},
	required: [
		"type",
		"id",
		"notedAt",
		"origin",
		"text"
	]
}, H = {
	type: "object",
	properties: {
		type: {
			type: "string",
			enum: ["PRINCIPAL"]
		},
		id: {
			type: "string",
			format: "uuid",
			description: "The unique identifier of a note of an order."
		},
		notedAt: {
			anyOf: [{ type: "string" }, {
				type: "string",
				format: "date-time",
				description: "An ISO 8601 formatted datetime string with timezone offset."
			}],
			description: "The date and time the note was created."
		},
		principal: {
			type: "string",
			minLength: 1,
			maxLength: 100,
			description: "The principal who crated the note."
		},
		text: {
			type: "string",
			minLength: 1,
			maxLength: 2500,
			description: "The text of the note."
		},
		locale: {
			anyOf: [{
				type: "string",
				minLength: 5,
				maxLength: 5,
				description: "Combination of ISO 639-1 and ISO 3166-1 alpha-2 separated by a hyphen."
			}, {
				type: "string",
				minLength: 2,
				maxLength: 2,
				description: "ISO 639-1 language code."
			}],
			description: "The locale of the note."
		},
		updatedAt: {
			anyOf: [{ type: "string" }, {
				type: "string",
				format: "date-time",
				description: "An ISO 8601 formatted datetime string with timezone offset."
			}],
			description: "The date and time the note was last updated."
		}
	},
	required: [
		"type",
		"id",
		"notedAt",
		"principal",
		"text"
	]
}, U = {
	oneOf: [{ $ref: "#/components/schemas/NoteFromImported" }, { $ref: "#/components/schemas/NoteFromPrincipal" }],
	discriminator: {
		propertyName: "type",
		mapping: {
			IMPORTED: "#/components/schemas/NoteFromImported",
			PRINCIPAL: "#/components/schemas/NoteFromPrincipal"
		}
	}
}, W = { anyOf: [
	{
		type: "object",
		properties: {
			address: { $ref: "#/components/schemas/Address" },
			location: {
				type: "object",
				properties: {
					name: {
						type: "string",
						minLength: 1,
						maxLength: 200,
						description: "The name of the pickup location."
					},
					code: {
						type: "string",
						minLength: 1,
						maxLength: 64,
						description: "The location code of the pickup location."
					},
					type: {
						type: "string",
						enum: [
							"CLICK_COLLECT",
							"PARCEL_LOCKER",
							"PARCEL_POINT",
							"POST_OFFICE",
							"POST_POINT"
						],
						description: "The bpost pickup location type."
					}
				},
				required: ["name", "type"],
				description: "The pickup location details."
			}
		},
		required: ["address", "location"],
		description: "The bpost pickup details."
	},
	{
		type: "object",
		properties: {
			address: { $ref: "#/components/schemas/Address" },
			location: {
				type: "object",
				properties: {
					name: {
						type: "string",
						minLength: 1,
						maxLength: 200,
						description: "The name of the pickup location."
					},
					code: {
						type: "string",
						minLength: 1,
						maxLength: 64,
						description: "The location code of the pickup location."
					}
				},
				required: ["name"],
				description: "The pickup location details."
			},
			retailNetworkId: {
				type: "string",
				enum: ["PNPNL-01", "PNPBE-01"],
				description: "PostNL Retail network ID."
			}
		},
		required: [
			"address",
			"location",
			"retailNetworkId"
		],
		description: "The PostNL pickup details."
	},
	{
		type: "object",
		properties: {
			address: { $ref: "#/components/schemas/Address" },
			location: {
				type: "object",
				properties: {
					name: {
						type: "string",
						minLength: 1,
						maxLength: 200,
						description: "The name of the pickup location."
					},
					code: {
						type: "string",
						minLength: 1,
						maxLength: 64,
						description: "The location code of the pickup location."
					}
				},
				required: ["name"],
				description: "The pickup location details."
			}
		},
		required: ["address", "location"],
		description: "The general pickup details."
	}
] }, G = {
	type: "object",
	properties: {
		carrier: { $ref: "#/components/schemas/Carrier" },
		direction: { $ref: "#/components/schemas/ShipmentDirection" },
		disableAutoDetectPickup: {
			type: "boolean",
			description: "When set to true, this field disables the automatic detection and change of a recipient's address to a pickup location, particularly when the recipient's address is very close to or within the same building as a pickup point."
		},
		packageType: { $ref: "#/components/schemas/PackageType" },
		recipient: {
			type: "object",
			properties: {
				address: { $ref: "#/components/schemas/Address" },
				contact: { $ref: "#/components/schemas/ContactMultiEmail" }
			},
			required: ["address", "contact"],
			description: "The recipient of the shipment."
		},
		customContractId: {
			type: "string",
			minLength: 1,
			maxLength: 50,
			description: "The unique identifier of the contract."
		},
		delivery: { $ref: "#/components/schemas/Delivery" },
		options: { $ref: "#/components/schemas/ShipmentOptionsCommon" },
		pickup: { $ref: "#/components/schemas/Pickup" },
		sender: {
			type: "object",
			properties: {
				address: { $ref: "#/components/schemas/Address" },
				contact: { $ref: "#/components/schemas/Contact" }
			},
			required: ["address", "contact"],
			description: "The sender of the shipment."
		},
		saveRecipientAddress: {
			type: "boolean",
			description: "When set to true, the recipient address is saved to the user's address book."
		}
	},
	required: [
		"carrier",
		"direction",
		"disableAutoDetectPickup",
		"packageType",
		"recipient"
	]
}, K = {
	type: "object",
	properties: {
		id: {
			type: "string",
			minLength: 1,
			description: "The unique identifier of the shipment."
		},
		carrier: { $ref: "#/components/schemas/Carrier" },
		createdAt: {
			anyOf: [{ type: "string" }, {
				type: "string",
				format: "date-time",
				description: "An ISO 8601 formatted datetime string with timezone offset."
			}],
			description: "The date when the shipment was created."
		},
		direction: { $ref: "#/components/schemas/ShipmentDirection" },
		hidden: {
			type: "boolean",
			description: "Whether the shipment is hidden."
		},
		packageType: { $ref: "#/components/schemas/PackageType" },
		recipient: {
			type: "object",
			properties: {
				address: { $ref: "#/components/schemas/Address" },
				contact: { $ref: "#/components/schemas/ContactMultiEmail" }
			},
			description: "The recipient of the shipment."
		},
		customContractId: {
			type: "string",
			minLength: 1,
			maxLength: 50,
			description: "The unique identifier of the contract."
		},
		customsDeclaration: { $ref: "#/components/schemas/CustomsDeclarationResponse" },
		delivery: { $ref: "#/components/schemas/Delivery" },
		dropOff: { $ref: "#/components/schemas/DropOff" },
		label: {
			anyOf: [{ $ref: "#/components/schemas/LabelWithBarcode" }, { $ref: "#/components/schemas/LabelWithoutBarcode" }],
			description: "The label of the package."
		},
		multicollo: {
			type: "object",
			properties: {
				id: {
					type: "string",
					format: "uuid",
					description: "The unique identifier for a multicollo shipment group."
				},
				totalPackages: {
					type: "integer",
					minimum: 2,
					maximum: 20,
					description: "The total number of individual packages included within this specific multicollo shipment group."
				}
			},
			required: ["id", "totalPackages"],
			description: "Details if this package is part of a multi-package (multicollo) shipment. A multicollo shipment is a group of packages belonging to the same shipment that are consolidated for combined labeling and potential cost reduction. This object will only be present if the package is part of such a group."
		},
		options: { $ref: "#/components/schemas/ShipmentOptions" },
		pickup: { $ref: "#/components/schemas/Pickup" },
		price: { $ref: "#/components/schemas/Money" },
		sender: {
			type: "object",
			properties: {
				address: { $ref: "#/components/schemas/Address" },
				contact: { $ref: "#/components/schemas/Contact" }
			},
			required: ["address", "contact"],
			description: "The sender of the shipment."
		}
	},
	required: [
		"id",
		"carrier",
		"createdAt",
		"direction",
		"hidden",
		"packageType",
		"recipient"
	],
	description: "The shipment properties of a package."
}, q = {
	type: "object",
	properties: {
		id: {
			type: "string",
			format: "uuid",
			description: "The unique identifier of a line of an order."
		},
		product: {
			type: "object",
			properties: {
				name: {
					type: "string",
					minLength: 1,
					maxLength: 250,
					description: "The name of the product."
				},
				ean: {
					type: "string",
					minLength: 1,
					maxLength: 13,
					description: "The EAN of the product."
				},
				sku: {
					type: "string",
					minLength: 1,
					maxLength: 200,
					description: "The SKU of the product."
				},
				id: {
					type: "string",
					format: "uuid",
					description: "Identifier of the product. This is always undefined when the `status` is `DISCOVERED` or `IMPORT_REQUESTED`, otherwise it is always defined."
				}
			},
			required: ["name"],
			description: "The product of an order line."
		},
		quantity: {
			type: "integer",
			minimum: 1,
			description: "The quantity of the product of the order line."
		},
		externalReference: { $ref: "#/components/schemas/LineExternalReference" },
		price: { allOf: [{ $ref: "#/components/schemas/Money" }, { description: "The price of the product of the order line." }] }
	},
	required: [
		"id",
		"product",
		"quantity"
	],
	description: "The line of the order"
}, J = {
	type: "object",
	properties: {
		customsDeclaration: { $ref: "#/components/schemas/CustomsDeclaration" },
		options: { $ref: "#/components/schemas/ShipmentOptionsPackage" },
		physicalProperties: { $ref: "#/components/schemas/PhysicalPropertiesWeightRequired" }
	}
}, Y = {
	type: "object",
	properties: {
		lines: {
			type: "array",
			items: {
				type: "object",
				properties: {
					id: {
						type: "string",
						format: "uuid",
						description: "The unique identifier of a line of an order."
					},
					quantity: {
						type: "integer",
						minimum: 1,
						description: "The quantity of the product of the order line."
					}
				},
				required: ["id", "quantity"]
			},
			minItems: 1,
			maxItems: 100
		},
		physicalProperties: { $ref: "#/components/schemas/PhysicalPropertiesWeightRequired" }
	}
}, X = {
	type: "object",
	properties: {
		id: {
			type: "string",
			format: "uuid",
			description: "The unique identifier of the package."
		},
		status: { $ref: "#/components/schemas/PackageStatus" },
		physicalProperties: { $ref: "#/components/schemas/PhysicalProperties" },
		lines: {
			type: "array",
			items: {
				type: "object",
				properties: {
					id: {
						type: "string",
						format: "uuid",
						description: "The unique identifier of a line of an order."
					},
					quantity: {
						type: "integer",
						minimum: 1,
						description: "The quantity that the package contains"
					}
				},
				required: ["id", "quantity"]
			},
			minItems: 1,
			maxItems: 100,
			description: "The order lines related to the package."
		},
		shipment: { $ref: "#/components/schemas/Shipment" }
	},
	required: ["id", "status"]
}, Z = {
	type: "object",
	properties: {
		customsDeclaration: { $ref: "#/components/schemas/CustomsDeclaration" },
		options: { $ref: "#/components/schemas/ShipmentOptionsPackage" },
		physicalProperties: { $ref: "#/components/schemas/PhysicalPropertiesWeightRequired" },
		shipment: {
			type: "object",
			properties: {
				carrier: { $ref: "#/components/schemas/CarrierToCreate" },
				direction: { $ref: "#/components/schemas/ShipmentDirection" },
				disableAutoDetectPickup: {
					type: "boolean",
					description: "When set to true, this field disables the automatic detection and change of a recipient's address to a pickup location, particularly when the recipient's address is very close to or within the same building as a pickup point."
				},
				packageType: { $ref: "#/components/schemas/PackageType" },
				recipient: {
					type: "object",
					properties: {
						address: { $ref: "#/components/schemas/Address" },
						contact: { $ref: "#/components/schemas/ContactMultiEmail" }
					},
					required: ["address", "contact"],
					description: "The recipient of the shipment."
				},
				customContractId: {
					type: "string",
					minLength: 1,
					maxLength: 50,
					description: "The unique identifier of the contract."
				},
				delivery: { $ref: "#/components/schemas/Delivery" },
				options: { $ref: "#/components/schemas/ShipmentOptionsCommon" },
				pickup: { $ref: "#/components/schemas/Pickup" },
				sender: {
					type: "object",
					properties: {
						address: { $ref: "#/components/schemas/Address" },
						contact: { $ref: "#/components/schemas/Contact" }
					},
					required: ["address", "contact"],
					description: "The sender of the shipment."
				},
				saveRecipientAddress: {
					type: "boolean",
					description: "When set to true, the recipient address is saved to the user's address book."
				}
			},
			required: [
				"carrier",
				"direction",
				"disableAutoDetectPickup",
				"packageType",
				"recipient"
			]
		}
	},
	required: ["shipment"]
}, Q = {
	type: "object",
	properties: {
		carrier: { $ref: "#/components/schemas/Carrier" },
		customContractId: {
			type: "string",
			minLength: 1,
			maxLength: 50,
			description: "The unique identifier of the contract."
		},
		customsDeclaration: { $ref: "#/components/schemas/CustomsDeclarationResponse" },
		delivery: { $ref: "#/components/schemas/Delivery" },
		direction: { $ref: "#/components/schemas/ShipmentDirection" },
		disableAutoDetectPickup: {
			type: "boolean",
			description: "When set to true, this field disables the automatic detection and change of a recipient's address to a pickup location, particularly when the recipient's address is very close to or within the same building as a pickup point."
		},
		numberOfLabels: {
			type: "integer",
			minimum: 1,
			maximum: 20
		},
		options: { $ref: "#/components/schemas/ShipmentOptions" },
		packageType: { $ref: "#/components/schemas/PackageType" },
		pickup: { $ref: "#/components/schemas/Pickup" },
		recipient: {
			type: "object",
			properties: {
				address: { $ref: "#/components/schemas/Address" },
				contact: { $ref: "#/components/schemas/ContactMultiEmail" }
			},
			description: "The recipient of the shipment."
		}
	},
	description: "The shipping preferences of the order. This should be used as default information when preparing packages for shipment."
}, $ = { anyOf: [{
	type: "object",
	properties: {
		shopId: {
			type: "string",
			minLength: 1,
			maxLength: 50,
			description: "The unique identifier of the shop."
		},
		customerReference: { $ref: "#/components/schemas/CustomerReference" },
		package: { $ref: "#/components/schemas/ShippablePackage" }
	},
	required: ["shopId", "package"]
}, {
	type: "object",
	properties: {
		shopId: {
			type: "string",
			minLength: 1,
			maxLength: 50,
			description: "The unique identifier of the shop."
		},
		customerReference: { $ref: "#/components/schemas/CustomerReference" },
		multicollo: {
			type: "object",
			properties: {
				packages: {
					type: "array",
					items: { $ref: "#/components/schemas/PackageCommon" },
					minItems: 2,
					maxItems: 20
				},
				shipment: {
					type: "object",
					properties: {
						carrier: { $ref: "#/components/schemas/CarrierToCreate" },
						direction: { $ref: "#/components/schemas/ShipmentDirection" },
						disableAutoDetectPickup: {
							type: "boolean",
							description: "When set to true, this field disables the automatic detection and change of a recipient's address to a pickup location, particularly when the recipient's address is very close to or within the same building as a pickup point."
						},
						packageType: { $ref: "#/components/schemas/PackageType" },
						recipient: {
							type: "object",
							properties: {
								address: { $ref: "#/components/schemas/Address" },
								contact: { $ref: "#/components/schemas/ContactMultiEmail" }
							},
							required: ["address", "contact"],
							description: "The recipient of the shipment."
						},
						customContractId: {
							type: "string",
							minLength: 1,
							maxLength: 50,
							description: "The unique identifier of the contract."
						},
						delivery: { $ref: "#/components/schemas/Delivery" },
						options: { $ref: "#/components/schemas/ShipmentOptionsCommon" },
						pickup: { $ref: "#/components/schemas/Pickup" },
						sender: {
							type: "object",
							properties: {
								address: { $ref: "#/components/schemas/Address" },
								contact: { $ref: "#/components/schemas/Contact" }
							},
							required: ["address", "contact"],
							description: "The sender of the shipment."
						},
						saveRecipientAddress: {
							type: "boolean",
							description: "When set to true, the recipient address is saved to the user's address book."
						}
					},
					required: [
						"carrier",
						"direction",
						"disableAutoDetectPickup",
						"packageType",
						"recipient"
					]
				}
			},
			required: ["packages", "shipment"]
		}
	},
	required: ["shopId", "multicollo"]
}] }, ee = {
	type: "object",
	properties: {
		id: {
			type: "string",
			format: "uuid",
			description: "The unique identifier of the order."
		},
		packages: {
			type: "array",
			items: { $ref: "#/components/schemas/PackageRequest" },
			minItems: 1,
			maxItems: 25
		}
	},
	required: ["id", "packages"]
}, te = {
	type: "object",
	properties: {
		id: {
			type: "string",
			format: "uuid",
			description: "The unique identifier of the package."
		},
		customsDeclaration: { $ref: "#/components/schemas/CustomsDeclaration" },
		options: { $ref: "#/components/schemas/ShipmentOptionsPackage" },
		physicalProperties: { $ref: "#/components/schemas/PhysicalPropertiesWeightRequired" }
	},
	required: ["id"]
}, ne = { anyOf: [{
	type: "object",
	properties: {
		id: {
			type: "string",
			format: "uuid",
			description: "The unique identifier of the order."
		},
		shipment: { $ref: "#/components/schemas/ShipmentRequest" },
		packages: {
			type: "array",
			items: { $ref: "#/components/schemas/PreparePackagesForShipmentPackage" },
			minItems: 1,
			maxItems: 25
		}
	},
	required: [
		"id",
		"shipment",
		"packages"
	]
}, {
	type: "object",
	properties: {
		id: {
			type: "string",
			format: "uuid",
			description: "The unique identifier of the order."
		},
		shipment: { $ref: "#/components/schemas/ShipmentRequest" },
		multicollo: {
			type: "array",
			items: { $ref: "#/components/schemas/PreparePackagesForShipmentPackage" },
			minItems: 2,
			maxItems: 25
		}
	},
	required: [
		"id",
		"shipment",
		"multicollo"
	]
}] }, re = {
	type: "object",
	properties: {
		id: {
			type: "string",
			format: "uuid",
			description: "The unique identifier of the order."
		},
		orderedAt: {
			anyOf: [{ type: "string" }, {
				type: "string",
				format: "date-time",
				description: "An ISO 8601 formatted datetime string with timezone offset."
			}],
			description: "The date and time the order was placed."
		},
		price: { $ref: "#/components/schemas/Money" },
		shopId: {
			type: "string",
			minLength: 1,
			maxLength: 50,
			description: "The unique identifier of the shop."
		},
		shortId: {
			type: "string",
			minLength: 9,
			maxLength: 9,
			description: "The short ID of the order."
		},
		status: { $ref: "#/components/schemas/OrderStatus" },
		assignedUserId: {
			type: "string",
			minLength: 1,
			maxLength: 50,
			description: "The user ID assigned to the order."
		},
		billingDetails: { $ref: "#/components/schemas/BillingDetails" },
		customerReference: { $ref: "#/components/schemas/CustomerReference" },
		externalReferences: { allOf: [{ $ref: "#/components/schemas/ExternalReferences" }, { description: "The external references of the order. These are read-only and automatically populated by the system based on the source." }] },
		lines: {
			type: "array",
			items: { $ref: "#/components/schemas/Line" },
			minItems: 1,
			maxItems: 100,
			description: "The lines of the order"
		},
		notes: {
			type: "array",
			items: { $ref: "#/components/schemas/Note" },
			minItems: 1,
			maxItems: 100,
			description: "The notes of the order."
		},
		packages: {
			type: "array",
			items: { $ref: "#/components/schemas/PackageResponse" },
			minItems: 1,
			maxItems: 25,
			description: "The packages of the order."
		},
		rules: {
			type: "object",
			properties: { setShippingPreferences: {
				type: "object",
				properties: {
					path: {
						type: "array",
						items: { anyOf: [{
							type: "object",
							properties: {
								id: {
									type: "string",
									format: "uuid",
									description: "The unique identifier of the rule."
								},
								name: {
									type: "string",
									description: "The name of the rule."
								}
							},
							required: ["id", "name"]
						}, {
							type: "object",
							properties: {
								id: {
									type: "string",
									format: "uuid",
									description: "The unique identifier of the rule group."
								},
								condition: { anyOf: [{
									type: "object",
									properties: { countryCode: { $ref: "#/components/schemas/CountryCode" } },
									required: ["countryCode"],
									additionalProperties: !1
								}, {
									type: "object",
									properties: { geoAreaCode: { $ref: "#/components/schemas/GeoAreaCode" } },
									required: ["geoAreaCode"],
									additionalProperties: !1
								}] }
							},
							required: ["id", "condition"]
						}] },
						minItems: 1,
						description: "The path of the rule."
					},
					appliedAt: {
						anyOf: [{ type: "string" }, {
							type: "string",
							format: "date-time",
							description: "An ISO 8601 formatted datetime string with timezone offset."
						}],
						description: "The date and time the rule was applied."
					},
					result: {
						type: "string",
						enum: ["PRESERVE", "REPLACE"],
						description: "How the rule was applied."
					}
				},
				required: [
					"path",
					"appliedAt",
					"result"
				]
			} },
			description: "The rules that have been applied to the order."
		},
		shipping: { $ref: "#/components/schemas/Shipping" }
	},
	required: [
		"id",
		"orderedAt",
		"price",
		"shopId",
		"shortId",
		"status"
	]
}, ie = {
	type: "object",
	properties: {
		type: {
			type: "string",
			enum: [
				"about:blank",
				"urn:problem:client",
				"urn:problem:invalid-request-syntax",
				"urn:problem:not-found",
				"urn:problem:server",
				"urn:problem:unauthorized",
				"urn:problem:unsupported-media-type"
			],
			description: "A URI reference that identifies the problem type."
		},
		status: {
			type: "integer",
			enum: [
				400,
				401,
				404,
				415,
				500
			],
			description: "The HTTP status code generated by the origin server."
		},
		title: {
			type: "string",
			minLength: 1,
			maxLength: 100,
			description: "A short human-readable summary of the problem type."
		},
		detail: {
			type: "string",
			minLength: 1,
			maxLength: 5e3,
			description: "A human-readable explanation specific to this occurrence of the problem."
		},
		instance: {
			type: "string",
			format: "uri",
			description: "A URI reference that identifies the specific occurrence of the problem."
		},
		cause: { description: "The cause of this problem when debug mode is enabled." }
	},
	required: [
		"type",
		"status",
		"title",
		"detail",
		"instance"
	]
}, ae = { allOf: [{ $ref: "#/components/schemas/ProblemDetails" }, {
	type: "object",
	properties: {
		type: {
			type: "string",
			enum: ["urn:problem:client"],
			description: "A URI reference that identifies the problem type."
		},
		status: {
			type: "number",
			enum: [400],
			description: "The HTTP status code generated by the origin server."
		},
		errors: {
			type: "array",
			items: {
				type: "object",
				properties: {
					detail: {
						type: "string",
						minLength: 1,
						maxLength: 5e3
					},
					pointer: {
						type: "string",
						minLength: 1,
						maxLength: 200,
						description: "This is a JSON pointer to the request (body, parameters, ...). When an aggregate has a conflict (e.g. not allowed due to the status) this value is for bulk request on the index (/body/{index}) and for any other on root (/)."
					}
				},
				required: ["detail", "pointer"]
			},
			minItems: 1,
			description: "Detailed information regarding the violations."
		}
	},
	required: ["errors"]
}] }, oe = { allOf: [{ $ref: "#/components/schemas/ProblemDetails" }, {
	type: "object",
	properties: {
		type: {
			type: "string",
			enum: ["urn:problem:server"],
			description: "A URI reference that identifies the problem type."
		},
		status: {
			type: "number",
			enum: [500],
			description: "The HTTP status code generated by the origin server."
		}
	}
}] }, se = { allOf: [{ $ref: "#/components/schemas/ProblemDetails" }, {
	type: "object",
	properties: {
		type: {
			type: "string",
			enum: ["urn:problem:invalid-request-syntax"],
			description: "A URI reference that identifies the problem type."
		},
		status: {
			type: "number",
			enum: [400],
			description: "The HTTP status code generated by the origin server."
		},
		errors: {
			type: "array",
			items: {
				type: "object",
				properties: {
					detail: {
						type: "string",
						minLength: 1,
						maxLength: 5e3
					},
					pointer: {
						type: "string",
						minLength: 1,
						maxLength: 200,
						description: "This is a JSON pointer to the request (body, parameters, ...). When an aggregate has a conflict (e.g. not allowed due to the status) this value is for bulk request on the index (/body/{index}) and for any other on root (/)."
					}
				},
				required: ["detail", "pointer"]
			},
			minItems: 1,
			description: "Detailed information regarding the syntactic violations."
		}
	},
	required: ["errors"]
}] }, ce = {
	BPOST: "BPOST",
	BRT: "BRT",
	CHEAP_CARGO: "CHEAP_CARGO",
	DHL_EUROPLUS: "DHL_EUROPLUS",
	DHL_FOR_YOU: "DHL_FOR_YOU",
	DHL_FREIGHT: "DHL_FREIGHT",
	DHL_PARCEL_CONNECT: "DHL_PARCEL_CONNECT",
	DPD: "DPD",
	GLS: "GLS",
	INPOST: "INPOST",
	POSTNL: "POSTNL",
	POSTE_ITALIANE: "POSTE_ITALIANE",
	SPRING: "SPRING",
	TRUNKRS: "TRUNKRS",
	UPS_EXPRESS_SAVER: "UPS_EXPRESS_SAVER",
	UPS_STANDARD: "UPS_STANDARD",
	VIA_TIM: "VIA_TIM",
	BOL: "BOL"
}, le = {
	BPOST: "BPOST",
	BRT: "BRT",
	CHEAP_CARGO: "CHEAP_CARGO",
	DHL_EUROPLUS: "DHL_EUROPLUS",
	DHL_FOR_YOU: "DHL_FOR_YOU",
	DHL_FREIGHT: "DHL_FREIGHT",
	DHL_PARCEL_CONNECT: "DHL_PARCEL_CONNECT",
	DPD: "DPD",
	GLS: "GLS",
	INPOST: "INPOST",
	POSTNL: "POSTNL",
	POSTE_ITALIANE: "POSTE_ITALIANE",
	SPRING: "SPRING",
	TRUNKRS: "TRUNKRS",
	UPS_EXPRESS_SAVER: "UPS_EXPRESS_SAVER",
	UPS_STANDARD: "UPS_STANDARD",
	VIA_TIM: "VIA_TIM"
}, ue = {
	EARLY_MORNING_DELIVERY: "EARLY_MORNING_DELIVERY",
	EVENING_DELIVERY: "EVENING_DELIVERY",
	EXPRESS_DELIVERY: "EXPRESS_DELIVERY",
	MORNING_DELIVERY: "MORNING_DELIVERY",
	PICKUP_EXPRESS_DELIVERY: "PICKUP_EXPRESS_DELIVERY",
	PICKUP_DELIVERY: "PICKUP_DELIVERY",
	SAME_DAY_DELIVERY: "SAME_DAY_DELIVERY",
	STANDARD_DELIVERY: "STANDARD_DELIVERY"
}, de = {
	EU: "EU",
	NON_EU: "NON_EU"
}, fe = {
	CANCELED: "CANCELED",
	COMPLETED: "COMPLETED",
	DISCOVERED: "DISCOVERED",
	IMPORT_REQUESTED: "IMPORT_REQUESTED",
	OPEN: "OPEN",
	PROCESSING: "PROCESSING",
	RETURNING: "RETURNING"
}, pe = {
	DIGITAL_STAMP: "DIGITAL_STAMP",
	ENVELOPE: "ENVELOPE",
	MAILBOX: "MAILBOX",
	PACKAGE: "PACKAGE",
	PALLET: "PALLET",
	SMALL_PACKAGE: "SMALL_PACKAGE",
	UNFRANKED: "UNFRANKED"
}, me = {
	PAID: "PAID",
	PENDING: "PENDING",
	UNPAID: "UNPAID"
}, he = {
	OUTBOUND: "OUTBOUND",
	INBOUND: "INBOUND"
}, ge = {
	ASC: "ASC",
	DESC: "DESC"
}, _e = {
	SalesChannelStatusChanged: "SalesChannelStatusChanged",
	ProductCreated: "ProductCreated",
	ProductUpdated: "ProductUpdated",
	OrderAlreadyDiscovered: "OrderAlreadyDiscovered",
	OrderCreated: "OrderCreated",
	OrderDeleted: "OrderDeleted",
	OrderRulesEvaluated: "OrderRulesEvaluated",
	OrderUpdated: "OrderUpdated",
	Printed: "Printed",
	PrintErrored: "PrintErrored"
}, ve = {
	Account: "account",
	Shop: "shop",
	Order: "ORDER",
	Product: "PRODUCT",
	Print: "PRINT"
}, ye = {
	Event: "Event",
	Order: "Order",
	Printing: "Printing",
	Product: "Product"
}, be = (e) => "package" in e, xe = (e) => "multicollo" in e, Se = (e) => "packages" in e, Ce = (e) => "multicollo" in e;
//#endregion
export { p as $, o as A, F as B, O as C, Q as Ct, D, E, s as F, B as G, L as H, u as I, d as J, R as K, M as L, i as M, c as N, e as O, l as P, re as Q, N as R, T as S, Z as St, A as T, f as U, P as V, z as W, H as X, V as Y, U as Z, ee as _, x as _t, _e as a, g as at, n as b, G as bt, ce as c, W as ct, de as d, ae as dt, J as et, fe as f, oe as ft, ge as g, b as gt, he as h, y as ht, Se as i, m as it, a as j, $ as k, le as l, te as lt, me as m, ie as mt, be as n, X as nt, ye as o, _ as ot, pe as p, se as pt, q, Ce as r, h as rt, ve as s, v as st, xe as t, Y as tt, ue as u, ne as ut, t as v, S as vt, k as w, w as wt, r as x, K as xt, j as y, C as yt, I as z };
